import { Box } from '@mui/material';
import { MdOutlineHelpOutline } from 'react-icons/md';
import { Item, WsColors } from 'wisestep-base';

import SettingsIndex from '../../../../components/SettingsIndex/SettingsIndex';

const OptionsHelpVideos = () => (
  <Box p={3}>
    <Item sx={{ backgroundColor: WsColors.White }}>
      <SettingsIndex
        options={[
          {
            label: 'Help Videos',
            icon: <MdOutlineHelpOutline size={25} />,
            url: '/faqs/job-videos',
            subOptions: [
              {
                label: 'Jobs',
                url: '/faqs/job-videos',
              },
              {
                label: 'Candidates',
                url: '/faqs/candidates-sourcing',
              },
              {
                label: 'Candidate Communication ',
                url: '/faqs/candidate-communication',
              },
              {
                label: 'Getting Setup ',
                url: '/faqs/getting-setup',
              },
              {
                label: 'Workspace Admin ',
                url: '/faqs/workspace-admin',
              },
            ],
          },
        ]}
      />
    </Item>
  </Box>
);

export default OptionsHelpVideos;
